

import { Box, Button, Modal, TextField, Typography } from "@mui/material";
import { Controller, useForm } from "react-hook-form";
import { useParams } from "react-router-dom";
import { useNiveles } from "../../../../context/SuperAdmin/OASContexts/NivelesContext";
import { NivelesFields } from "../../../../interfaces/SuperAdmin/Pages/iDataNivel";
import { PostIndicadorFields } from "../../../../interfaces/SuperAdmin/Pages/iDataIndicador";
import { useSingleObjetivo } from "../../../../context/SuperAdmin/OASContexts/SingleObjetivoContext";

const CreateIndicadorModal = () => {
  const { idObjetivo } = useParams();
  const { isCreateModalOpen, toggleCreateModal, isCreating, indicadorCreate } =
    useSingleObjetivo();

  const {
    control,
    formState: { errors },
    handleSubmit,
    reset,
  } = useForm<PostIndicadorFields>();

  // Función para manejar el envío del formulario
  const handleSubmitForm = (data: PostIndicadorFields) => {
    if (idObjetivo) {
      const body: PostIndicadorFields = {
        ...data,
        id_objetivo: idObjetivo,
      };
      console.log(body);

      indicadorCreate(body);
      reset();
    }
  };

  // Función para cerrar el modal
  const handleClose = () => {
    if (!isCreating) {
      reset();
      toggleCreateModal(false);
    }
  };

  return (
    <Modal
      open={isCreateModalOpen}
      onClose={handleClose}
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        bgcolor: "rgba(0, 0, 0, 0.3)", // Fondo negro con opacidad
      }}
    >
      <Box
        component="form"
        sx={{
          width: 400,
          bgcolor: "background.paper",
          borderRadius: 2,
          p: 4,
          boxShadow: 24,
          minWidth: "600px",
          display: "flex",
          flexDirection: "column",
          gap: 3,
        }}
        onSubmit={handleSubmit(handleSubmitForm)}
      >
        <Typography variant="h6" component="h2">
          Nuevo indicador
        </Typography>

        {/* Campo Nombre */}
        <Box sx={{ display: "flex", flexDirection: "column" }}>
          <Typography variant="body1" sx={{ fontWeight: 500 }}>
            Nombre
          </Typography>
          <Controller
            name="nombre"
            control={control}
            rules={{ required: "El nombre es obligatorio" }}
            render={({ field }) => (
              <TextField
                {...field}
                fullWidth
                margin="normal"
                error={!!errors.nombre}
                helperText={errors.nombre?.message}
                disabled={isCreating}
              />
            )}
          />
        </Box>

        <Box sx={{ mt: 3, textAlign: "right" }}>
          <Button
            variant="contained"
            sx={{ background: "#336B87" }}
            disabled={isCreating}
            type="submit"
          >
            Crear
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default CreateIndicadorModal;

